<span class="p-2" placement="top" ngbTooltip="This field is required.">
  <small class="mx-2 text-danger">(Required)</small>
</span>
